exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#admin-menu {\n  border-radius: 18px;\n  width: 42px;\n  transition: width 0.5s;\n  -webkit-transition: width 0.5s; }\n  #admin-menu span {\n    display: none; }\n  #admin-menu:hover {\n    width: 160px; }\n    #admin-menu:hover span {\n      display: inherit; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/dfm/cryosoft/ui/src/app/components/app-header/app-header.component.scss
// module id = ../../../../../src/app/components/app-header/app-header.component.scss
// module chunks = main